import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "weightFilled"
const WeightFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 2.25C13.657 2.25 15 3.593 15 5.25 15 5.797 14.853 6.309 14.598 6.75H17.366C18.098 6.75 18.724 7.28 18.845 8.003L20.845 20.003C20.997 20.917 20.292 21.75 19.365 21.75H4.636C3.709 21.75 3.004 20.918 3.156 20.003L5.157 8.003C5.276 7.28 5.903 6.75 6.636 6.75H9.403C9.147 6.309 9 5.797 9 5.25 9 3.593 10.343 2.25 12 2.25M14.649 11.605C12.973 11.605 11.942 12.667 11.942 14.466 11.942 16.29 12.973 17.346 14.684 17.346 16.264 17.346 17.202 16.419 17.202 14.905V14.224H14.826V15.193H15.841L15.838 15.278C15.799 15.835 15.353 16.212 14.715 16.212 13.904 16.212 13.38 15.547 13.38 14.447 13.38 13.367 13.853 12.74 14.653 12.74 15.195 12.74 15.611 13.04 15.75 13.53H17.145C17.003 12.401 15.995 11.606 14.65 11.606M6.936 17.25H8.347V15.681L8.82 15.081 10.235 17.25H11.893L9.847 14.166 11.781 11.702H10.266L8.378 14.14H8.348V11.701H6.935zM12 3.75C11.172 3.75 10.5 4.422 10.5 5.25S11.172 6.75 12 6.75 13.5 6.078 13.5 5.25 12.828 3.75 12 3.75"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WeightFilledIcon
